import { combineReducers } from 'redux';

import coordinates from './reducers/coordinates';
import properties from './reducers/properties';
import duplicates from './reducers/duplicates';
import savedSearches from './reducers/saved_searches';
import search from './reducers/search';
import selectList from './reducers/select_list';
import query from './reducers/query';
import session from './reducers/session';
import transfers from './reducers/transfers';
import ui from './reducers/ui';


const nullReducer = state => ({ ...state });

export default combineReducers({
  coordinates,
  paths: nullReducer,
  properties,
  dromoImporterProps: nullReducer,
  duplicates,
  features: nullReducer,
  query,
  savedSearches,
  search,
  selectList,
  session,
  static: nullReducer,
  scope: nullReducer,
  transfers,
  ui
});
